const ADD_FROM_FRIENDS_REGISTRY = '/add-from-friends-registry';

export const FRIENDS_REGISTRY_ROUTES = {
  addToFriendsRegistryDetails: `${ADD_FROM_FRIENDS_REGISTRY}/:transitionalRegistryId`,
  addToFriendsRegistryIndex: `${ADD_FROM_FRIENDS_REGISTRY}`,
} as const;

export const CATEGORY = 'AddFromFriendsRegistry';
export const ACTION = 'ButtonInteracted';

export const HOW_IT_WORS_SECTION_ID = 'how';

export const AFFR_BANNER_INPUT_SECTION_ID = 'input';
export const AFFR_BANNER_INPUT_INPUT_ID = 'input-field';

export const AFFR_SCANNED_LIST_SECTION_ID = 'scanned-list';
